import { render, staticRenderFns } from "./CreateBankAccount.vue?vue&type=template&id=62131c22&scoped=true&"
import script from "./CreateBankAccount.vue?vue&type=script&lang=js&"
export * from "./CreateBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateBankAccount.vue?vue&type=style&index=0&id=62131c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62131c22",
  null
  
)

export default component.exports